export const SDK_VERSION = '7.40.0';
